import React from 'react';
import { Checkbox } from 'antd';
import Text from 'components/Text/Text';

interface IProps {
	toggleRememberMyChoice: () => void;
	rememberMyChoice: boolean;
}

export const RememberMyChoiceCheckBox: React.FC<IProps> = ({ toggleRememberMyChoice, rememberMyChoice }) => {
	return (
		<Checkbox onChange={toggleRememberMyChoice} checked={rememberMyChoice} data-test="RememberMyChoiceCheckBox">
			<Text translationNameSpace="modals" translationKey="rememberMyChoice" asFragment={true} />
		</Checkbox>
	);
};
